import React from 'react';

const AnimationVideoBanner = () =>{
    return (
        <>
        <div className='cadServicesAnimationBanner cadModelingMain cadAboutBanner cadContactBanner'>
            <video className='videoTag' autoPlay loop muted>
                <source src="/videos/animation-video-page.mp4" type='video/mp4' />
            </video>
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1><span>3</span>D Animations</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default AnimationVideoBanner;